var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewSalaryGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.1875C18 6.1875 14.625 0 9 0C3.375 0 0 6.1875 0 6.1875C0 6.1875 3.375 12.375 9 12.375C14.625 12.375 18 6.1875 18 6.1875ZM1.31963 6.1875C1.86358 5.36076 2.48922 4.59077 3.18712 3.88912C4.635 2.439 6.615 1.125 9 1.125C11.385 1.125 13.3639 2.439 14.814 3.88912C15.5119 4.59077 16.1375 5.36076 16.6815 6.1875C16.6163 6.28538 16.5443 6.39337 16.4621 6.5115C16.0853 7.0515 15.5284 7.7715 14.814 8.48588C13.3639 9.936 11.3839 11.25 9 11.25C6.615 11.25 4.63613 9.936 3.186 8.48588C2.4881 7.78422 1.86246 7.01423 1.3185 6.1875H1.31963Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.375C8.25408 3.375 7.53871 3.67132 7.01126 4.19876C6.48382 4.72621 6.1875 5.44158 6.1875 6.1875C6.1875 6.93342 6.48382 7.64879 7.01126 8.17624C7.53871 8.70368 8.25408 9 9 9C9.74592 9 10.4613 8.70368 10.9887 8.17624C11.5162 7.64879 11.8125 6.93342 11.8125 6.1875C11.8125 5.44158 11.5162 4.72621 10.9887 4.19876C10.4613 3.67132 9.74592 3.375 9 3.375ZM5.0625 6.1875C5.0625 5.14321 5.47734 4.14169 6.21577 3.40327C6.95419 2.66484 7.95571 2.25 9 2.25C10.0443 2.25 11.0458 2.66484 11.7842 3.40327C12.5227 4.14169 12.9375 5.14321 12.9375 6.1875C12.9375 7.23179 12.5227 8.23331 11.7842 8.97173C11.0458 9.71016 10.0443 10.125 9 10.125C7.95571 10.125 6.95419 9.71016 6.21577 8.97173C5.47734 8.23331 5.0625 7.23179 5.0625 6.1875Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSalaryGrey);
export default __webpack_public_path__ + "static/media/view_salary_grey.eecfcfed81d1a2b4123924c526916815.svg";
export { ForwardRef as ReactComponent };